<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Supplier Balances</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="7">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <!-- start of table -->
            <v-data-table
              :items-per-page="200"
              :mobile-breakpoint="zeroValue"
              :headers="headers"
              :items="balances"
              :search="search"
            ></v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    zeroValue: 0,
    headers: [
      { text: "Supplier", value: "ocrd.Name" },
      { text: "Balance", value: "Balance" },
    ],
    balances: [],
  }),
  methods: {
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/supplier-balances`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.balances = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getAccounts();
  },
};
</script>